import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import escape from '../utils/escape';
import classnames from 'classnames';

import ListItem from './ListItem';
import { sortByName } from '../utils/sorting';

import projectActions from '../actions/projectActionCreators';

require('./AutoTaskInput.less');

/*
 * Component for the automatic input of projects. Each time a project is selected, it will
 * send a dispatch which will put the selected project in the store (projects.selectedProject).
 */
class AutoProjectInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        let projects = this.prefilterProjects(props.projects);

        if (projects.length > 0 && projects[0].id) {
            projects.sort(sortByName);
        }

        this.state = {
            text: "",
            selectedIndex: 0,
            scrollTop: 0,
            filteredProjects: projects,
            projects: projects,
            focused: false,
            blurTimeout: null,
            width: 0
        };
    }

  prefilterProjects(givenProjects) {
    let projects = givenProjects.filter( project =>  !(this.props.hideArchived && project.archived) );

    if (this.props.filterByDate) {
      projects = projects.filter(project => {
        if (project.startDate && this.props.filterByDate.format("YYYY-MM-DD") < project.startDate) return false;

        return !(project.endDate && this.props.filterByDate.format("YYYY-MM-DD") > project.endDate);


      });
    }

    if (this.props.filterByDateRange) {
      projects = projects.filter(project => {
        return !(project.startDate && this.props.filterByDateRange.startDate.format("YYYY-MM-DD") < project.startDate) ||
            !(project.endDate && this.props.filterByDateRange.endDate.format("YYYY-MM-DD") > project.endDate);
      });
    }

    return projects;
  }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        this.props.dispatch(projectActions.setSelectedProject(null));
    };

    componentDidMount = () => {
        this.setState({
            popupWidth: ReactDOM.findDOMNode(this.refs.projectField).offsetWidth,
            popupLeft: ReactDOM.findDOMNode(this.refs.projectField).offsetLeft,
            popupTop: ReactDOM.findDOMNode(this.refs.projectField).offsetHeight + ReactDOM.findDOMNode(this.refs.projectField).offsetTop - 1
        });
    };

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.clearInputs === true)
            this.clear();

        this.setState({
            projects: this.prefilterProjects(nextProps.projects),
            text: nextProps.selectedProject ? nextProps.selectedProject.name : this.state.text
        });
    };

    componentWillUnmount = () => { clearTimeout(this.state.blurTimeout); };

    // EVENT HANDLERS

    handleBlur = () => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    };

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.props.dispatch(projectActions.setSelectedProject(null));
        setTimeout(() => {
            this.setState({
                text: text,
                selectedIndex: 0,
                scrollTop: 0,
                focused: true
            });
        }, 50);

        if (this.props.handleTextChange)
            this.props.handleTextChange();

        this.filterProjects(text);

        if (text === "") this.clear();
    };

    handleFocus = () => {
        this.setState({
            focused: true,
            selectedIndex: 0
        });

        this.filterProjects(this.state.text);
    };

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab" && !this.props.disableTab && (this.state.selectedIndex == 0 && !(!this.state.text || this.state.text.trim() === ''))) {
            keyEvent.key = "Enter";
            this.handleKeyPress(keyEvent);
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop - ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });
        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredProjects.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop + ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredProjects: this.state.projects.filter(project => filter.test(project.name))
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({ focused: false });
        }
    };

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            // filter once again but this time trimmed
            this.filterProjects(this.state.text.trim());

            let selectedProject = this.state.filteredProjects[this.state.selectedIndex];
            this.props.dispatch(projectActions.setSelectedProject(selectedProject));

            this.setState({
                text: selectedProject.name,
                scrollTop: 0,
                focused: false
            },
            this.handleMouseDown(this.state.selectedIndex));

            keyEvent.stopPropagation();
        }
    };

    handleMouseDown = (selectedIndex) => {
        let selectedProject = this.state.filteredProjects[selectedIndex];

        if (this.props.handleFunction) this.props.handleFunction(selectedProject);

        this.props.dispatch(projectActions.setSelectedProject(selectedProject));

        if (this.props.keepAfterClick) {
            this.setState({ text: selectedProject.name });
        } else {
            this.setState({
                text: '',
                selectedIndex: 0,
                scrollTop: 0,
                focused: false
            });
        }
    };

    handleMouseOver = (selectedIndex)  => { this.setState({ selectedIndex: selectedIndex }); };

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({ blurTimeout: null });
            ReactDOM.findDOMNode(this.refs.projectField).focus();
        }
    };

    // OTHER METHODS

    clear = () => {
        if(this.props.handleTextChange)
            this.props.handleTextChange();
        this.props.dispatch(projectActions.setSelectedProject(null));
        setTimeout(() => {
                this.setState({
                text: "",
                selectedIndex: 0,
                scrollTop: 0,
                filteredProjects: this.state.projects,
                focused: false
            });
        }, 100);
    };

    filterProjects = (userInput) => {
        if (userInput === '') {
            this.setState({ filteredProjects: this.state.projects });

            return;
        }

        let filter = new RegExp(escape.escapeInput(userInput), 'i');

        this.setState({ filteredProjects: this.state.projects.filter(project => filter.test(project.name)) });
    };

    // RENDER METHOD

    render = () => {
        return (
            <span>
                <input
                    className="form-control"
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                    placeholder={this.props.placeholder}
                    ref="projectField"
                    style={{display: "inline"}}
                    title={this.state.text && this.state.text.length > 50 ? this.state.text : null}
                    type="text"
                    value={this.state.text ? this.state.text : ""}
                    />
                {
                    this.props.enableClear && this.state.text && this.state.text !== ''
                    ? <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : this.props.topOffset ? this.props.topOffset : "5px"}} onClick={this.clear} className="filter-clear">
                         <span><span className="md-clear"/></span>
                      </a>
                    : null
                }
                {
                    this.state.focused && this.state.filteredProjects.length > 0
                    ?
                        (
                            <ul className="popup" onScroll={this.handleScroll} style={{ "width": this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.state.filteredProjects.map((project, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        return (<ListItem
                                                    classNames={classNames}
                                                    id={project.id}
                                                    index={i}
                                                    key={project.id}
                                                    mouseDown={this.handleMouseDown}
                                                    mouseOver={this.handleMouseOver}
                                                    name={project.name}
                                                    ref={"item" + i}
                                                    />);
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoProjectInput.propTypes = {
    disableTab: PropTypes.bool,
    dispatch: PropTypes.func,
    enableClear: PropTypes.bool,
    handleFunction: PropTypes.func,
    handleTextChange: PropTypes.func,
    filterByDate: PropTypes.object,
    hideArchived: PropTypes.bool,
    keepAfterClick: PropTypes.bool,
    placeholder: PropTypes.string,
    projects: PropTypes.array,
    selectedProject: PropTypes.object,
    selectedTask: PropTypes.object,
    topOffset: PropTypes.string,
    filterByDateRange: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        selectedProject: state.projects.selectedProject,
        selectedTask: state.tasks.selectedTask
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
) (AutoProjectInput);



/** WEBPACK FOOTER **
 ** ./src/app/components/AutoProjectInput.js
 **/